import { fbt } from 'fbtee'
import { CalendarPlus } from 'lucide-react'
import { useTransitionNavigate } from '../../lib/viewTransition'
import { Button } from '../../components/ui/button'

/** Empty state for a group with no linked events: points at Discover, where events get linked. */
export function LinkEventEmptyCard({ canLink }: { canLink: boolean }) {
  const navigate = useTransitionNavigate()
  return (
    <section
      className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-border bg-card px-4 py-6 text-center"
      data-testid="group-link-event-empty"
    >
      <CalendarPlus className="size-8 text-muted-foreground" />
      <div className="space-y-1">
        <p className="font-medium">
          {fbt('No plans yet', 'Title of the empty state on a group page with no linked events')}
        </p>
        <p className="text-sm text-muted-foreground">
          {fbt(
            'Find an event and link this group from its page to plan it together.',
            'Body of the empty state on a group page with no linked events',
          )}
        </p>
      </div>
      {canLink && (
        <Button onClick={() => navigate('/discover')}>
          {fbt('Link an event', 'Button in the group page empty state that opens Discover to find an event to link')}
        </Button>
      )}
    </section>
  )
}
